<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisTabs from 'dashboard/components-next/LaisTabs.vue';
import RealEstateBrokerAddressSearch from './RealEstateBrokerAddressSearch.vue';

const props = defineProps({
  status: { type: String, default: '' },
  summary: { type: Array, default: () => [] },
  filters: { type: Object, default: () => ({}) },
  order: { type: Object, default: () => ({ sort: 'data', direction: 'desc' }) },
  addresses: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
});

const emit = defineEmits(['selectStatus', 'applyAddress', 'setOrder']);
const { t } = useI18n();
const statusLabel = key => {
  if (key === 'em_andamento')
    return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.EM_ANDAMENTO');
  if (key === 'liberado')
    return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.LIBERADO');
  if (key === 'solicitado')
    return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.SOLICITADO');
  if (key === 'em_transferencia')
    return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.EM_TRANSFERENCIA');
  if (key === 'concluido')
    return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.CONCLUIDO');
  return t('REAL_ESTATE_BROKER_DASHBOARD.STATUS.CANCELADO');
};
const tabs = computed(() =>
  props.summary
    .filter(item => item.key !== 'total')
    .map(item => ({
      id: item.key,
      label: statusLabel(item.key),
      badge: item.count,
    }))
);
const orderValue = computed(
  () => `${props.order.sort}:${props.order.direction}`
);
const orderOptions = computed(() => [
  { value: 'data:desc', label: t('REAL_ESTATE_BROKER_DASHBOARD.ORDER.RECENT') },
  { value: 'data:asc', label: t('REAL_ESTATE_BROKER_DASHBOARD.ORDER.OLDEST') },
  {
    value: 'valor:desc',
    label: t('REAL_ESTATE_BROKER_DASHBOARD.ORDER.HIGHEST_VALUE'),
  },
  {
    value: 'valor:asc',
    label: t('REAL_ESTATE_BROKER_DASHBOARD.ORDER.LOWEST_VALUE'),
  },
]);

const selectOrder = event => {
  const [sort, direction] = event.target.value.split(':');
  emit('setOrder', { sort, direction });
};
</script>

<template>
  <section
    class="space-y-4 rounded-lais border border-lais-border-soft bg-white p-4 shadow-lais-card"
  >
    <h2 class="font-redHatDisplay text-xl font-semibold text-lais-text">
      {{ t('REAL_ESTATE_BROKER_DASHBOARD.TABLE.TITLE') }}
    </h2>
    <LaisTabs
      :model-value="status"
      :tabs="tabs"
      :aria-label="t('REAL_ESTATE_BROKER_DASHBOARD.FILTERS.TABS')"
      @change="emit('selectStatus', $event)"
    />
    <div class="grid gap-3 md:grid-cols-[minmax(0,1fr)_220px]">
      <RealEstateBrokerAddressSearch
        :filters="filters"
        :options="addresses"
        :loading="loading"
        @apply="emit('applyAddress', $event)"
      />
      <label class="sr-only" for="broker-commission-order">{{
        t('REAL_ESTATE_BROKER_DASHBOARD.FILTERS.ORDER')
      }}</label>
      <select
        id="broker-commission-order"
        :value="orderValue"
        :disabled="loading"
        class="h-10 rounded-lais border border-lais-border bg-white px-3 text-sm text-lais-text"
        @change="selectOrder"
      >
        <option
          v-for="option in orderOptions"
          :key="option.value"
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>
    </div>
  </section>
</template>
